import { call, put, takeLatest } from "redux-saga/effects";
import { heApi } from "../../../api/category/heApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { eDmHeActionIds } from "../../action-types/category/IDmHeActions";

const mainAction = rootActions.category.he;
export function* heSaga(): any {
    yield takeLatest(eDmHeActionIds.LOAD_START, loadWorker);
}
function* loadWorker(): any {
    const res: IBaseResponse = yield call(heApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải danh sách Hệ"));
    }
}
